export default __webpack_public_path__ + "static/banner-bbf17eeadc87c7c14586fdeac0b98e9d.png";